// Утилиты для работы с Service Worker
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
)

// Регистрация Service Worker
export function register(config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(import.meta.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) {
      return
    }

    window.addEventListener('load', () => {
      const swUrl = `${import.meta.env.PUBLIC_URL}/sw.js`

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config)
        navigator.serviceWorker.ready.then(() => {
          console.log('Service Worker ready in localhost mode')
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
  }
}

// Регистрация валидного SW
function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      console.log('Service Worker registered:', registration)
      
      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (installingWorker == null) {
          return
        }
        
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content available, please refresh')
              
              if (config && config.onUpdate) {
                config.onUpdate(registration)
              }
            } else {
              console.log('Content cached for offline use')
              
              if (config && config.onSuccess) {
                config.onSuccess(registration)
              }
            }
          }
        }
      }
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error)
    })
}

// Проверка валидности SW
function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then(response => {
      const contentType = response.headers.get('content-type')
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {
      console.log('No internet connection. App running in offline mode.')
    })
}

// Отмена регистрации SW
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister()
      })
      .catch(error => {
        console.error(error.message)
      })
  }
}

// Обновление SW
export function updateServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.update()
      })
      .catch(error => {
        console.error('Service Worker update failed:', error)
      })
  }
}

// Отправка сообщения SW
export function sendMessageToSW(message) {
  return new Promise((resolve, reject) => {
    if (!('serviceWorker' in navigator)) {
      reject(new Error('Service Worker not supported'))
      return
    }

    navigator.serviceWorker.ready
      .then(registration => {
        if (!registration.active) {
          reject(new Error('Service Worker not active'))
          return
        }

        const messageChannel = new MessageChannel()
        messageChannel.port1.onmessage = (event) => {
          resolve(event.data)
        }

        registration.active.postMessage(message, [messageChannel.port2])
      })
      .catch(reject)
  })
}

// Очистка кэша
export function clearCache(cacheName) {
  return sendMessageToSW({
    type: 'CLEAR_CACHE',
    payload: { cacheName }
  })
}

// Предзагрузка маршрутов
export function preloadRoutes(routes) {
  return sendMessageToSW({
    type: 'PRELOAD_ROUTES',
    payload: { routes }
  })
}

// Получение версии SW
export function getServiceWorkerVersion() {
  return sendMessageToSW({
    type: 'GET_VERSION'
  })
}

// Хук для работы с SW
export function useServiceWorker() {
  const [isSupported, setIsSupported] = React.useState(false)
  const [isRegistered, setIsRegistered] = React.useState(false)
  const [updateAvailable, setUpdateAvailable] = React.useState(false)

  React.useEffect(() => {
    setIsSupported('serviceWorker' in navigator)

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(() => {
        setIsRegistered(true)
      })

      // Слушаем обновления
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        setUpdateAvailable(true)
      })
    }
  }, [])

  const update = React.useCallback(() => {
    updateServiceWorker()
    setUpdateAvailable(false)
  }, [])

  const clearAllCaches = React.useCallback(() => {
    return clearCache()
  }, [])

  const preload = React.useCallback((routes) => {
    return preloadRoutes(routes)
  }, [])

  return {
    isSupported,
    isRegistered,
    updateAvailable,
    update,
    clearCache: clearAllCaches,
    preloadRoutes: preload
  }
}